var _defs, _g, _g2, _g3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "650.3 227.28 638 651.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        font-family: MyriadPro-Semibold, 'Myriad Pro';\n        font-size: 33px;\n        font-weight: 600;\n      }\n\n      .st0, .st1, .st2 {\n        fill: #fff;\n      }\n\n      .st2 {\n        font-family: BahijTheSansArabic-Bold, 'Bahij TheSansArabic';\n        font-size: 30px;\n        font-weight: 700;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M894.7,768.3c-10.2-5.9-21.2-3.5-25-2.5l38.4-22h-51.9l-42.5,30h39.5c3.7.5,6.5,3.6,6.4,7.1,0,3.9-3.6,7.2-7.8,6.9h-70.1v-48h-36v59h139.5c2-.2,4.8-.8,7.7-2.3,5.9-3.1,13-10.4,11.4-17.6-1.3-5.6-6.5-8.8-9.6-10.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "650.3 820.8 697.3 820.8 738.9 766.8 701.3 766.8 650.3 820.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1287.2,583.9h-198.8c.3-8.8.6-17.6,1-26.5,1.9-45.7-2.3-86.6-18.2-129.6-45-121.1-170-177.4-290.5-194.6-1.5-1.2,0-1.8,1.5-2,6.9-.8,15-1.5,22-2,124.7-9.4,280.9,14.6,378.6,97.9,73.7,62.9,108.9,160.5,104.4,256.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M654.9,583.9c-2.3-2.3,15.4-42.8,18.1-48.3,27.3-56.6,74.1-109.8,130.9-137.9,62.9-31.2,136.8-36.5,205.7-27.1-.5.7-1,1.2-1.6,1.6-.7.5-1.4.7-1.8.8-.1,0-.2,0-.2,0-.5.1-49.2,12.9-78.5,31.6-50.9,32.5-74.1,102.6-75.9,155.1-.3,9.9.1,18.3.6,24.1h-197.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1188.7,757.6h2.4c-.8,0-1.6,0-2.4,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1031.5 724.8 991 724.8 953.9 704 941.1 710.8 940.6 724.8 903.6 724.8 903.6 669.3 905.1 667.8 939.1 667.8 940.6 669.3 940.6 693.3 942.6 694.4 986 667.8 1036.4 667.8 1031.8 670.7 985.5 696.3 1031.5 724.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "702.8 668.3 755.7 668.3 802.7 724.8 761.3 724.8 729.3 679.8 729.3 679.8 696.6 724.5 657.8 725.3 702.8 668.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M897.8,682.1l-51.1.7v7h51.1v15h-51.1v20h.5c-.7,0-40.1,1.2-41.2-.2l-.2-56.7h92.1v14.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 1244.3,
    y: 738.8,
    width: 39,
    height: 59.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 650.3,
    y: 617.3,
    width: 638,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 903.6,
    y: 667.8,
    width: 37.1,
    height: 56.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1087 668.3 1139.9 668.3 1186.9 724.8 1145.4 724.8 1113.4 679.8 1113.4 679.8 1080.8 724.5 1042 725.3 1087 668.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1250.3,703.3l30,21.5h-48.5l-36.5-28c10.3-1.4,25.9,1.9,35.5,0,2.1-.4,7-4.1,7.5-6.5,1-5.3-2.1-8.1-6.2-9.5h-71.8v-13.7h36.3c17.3,0,35.2.8,51.1,1.7,6.2.4,14.8.1,22.1,2.2,6.1,1.7,11.2,5.1,12.9,11.8,4.3,16.6-19.7,18.3-30,19-1.5,0-2.9-.8-2.5,1.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 1102.2,
    y: 745.7,
    width: 26.2,
    height: 24
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1000.5 870.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0627\u0644\u0642\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0627\u0628\u0636\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0640\u0629")), /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(650.3 870.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HOLDING")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1143.4,745.8v34h47.1v19h45.8v-53h-92.9ZM1198.1,772.8h-15v-15.3h15v15.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1205.5,785.4v13.3h-303.8c1.9-.2,4.5-.8,7.2-2.2,4.1-2.2,8.8-6.3,10.7-11.1h285.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.96d88b5e8d05c341eca41352c08f4fda.svg";
export { ForwardRef as ReactComponent };